module.exports = __webpack_public_path__ + "static/media/sbo_logo.f70b3cad.svg";